import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/HelloWorld.vue'
import HistoryIntroduction from '../components/calligraphy/HistoryIntroduction.vue'
import ClassicWorks from '../components/calligraphy/ClassicWorks.vue'
import PersonalWorks from '../components/calligraphy/PersonalWorks.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/history', name: 'HistoryIntroduction', component: HistoryIntroduction },
  { path: '/classic', name: 'ClassicWorks', component: ClassicWorks },
  { path: '/personal', name: 'PersonalWorks', component: PersonalWorks },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router